import { GrowthContent } from '@mc/api'
import { HeroCTA } from '../HeroCTA'
import { HeroDesktopDualImageTiles } from './HeroDesktopDualImageTiles'
import { HeroDesktopSingleImageTile } from './HeroDesktopSingleImageTile'

type HeroDesktopProps = {
  heading: string
  courseA: GrowthContent
  courseB: GrowthContent
}

export const HeroDesktop = ({
  heading,
  courseA,
  courseB,
}: HeroDesktopProps) => (
  <section
    className='container d-none d-lg-flex mc-mt-6'
    style={{ position: 'relative', minHeight: '360px' }}
  >
    <div
      className='row mc-mt-10 mc-w-100'
      style={{
        zIndex: 1,
      }}
    >
      <div className='col-8'>
        <h1 className='mc-mb-5 mc-text-d3 mc-text--brand mc-text--uppercase mc-text--left'>
          {heading}
        </h1>
        <HeroCTA headline={heading} />
      </div>
    </div>
    <div
      className='row d-flex'
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
      }}
    >
      <SubcatHeroImages courseA={courseA} courseB={courseB} />
    </div>
  </section>
)

const SubcatHeroImages = ({
  courseA,
  courseB,
}: Omit<HeroDesktopProps, 'heading'>) => {
  if (courseA?.primary16x9 && courseB?.primary16x9) {
    return (
      <HeroDesktopDualImageTiles
        img1Url={courseA.primary16x9}
        img1Alt={courseA.instructorName || ''}
        img2Url={courseB.primary16x9}
        img2Alt={courseB.instructorName || ''}
      />
    )
  }

  if (courseA?.primary16x9) {
    return (
      <HeroDesktopSingleImageTile
        imgUrl={courseA.primary16x9}
        imgAlt={courseA.instructorName || ''}
      />
    )
  }

  return null
}
